import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import {
  UNITED_STATES_COUNTRY_CODE,
  ZIP_CODE_NON_US_MAX_LENGTH,
  ZIP_CODE_US_MAX_LENGTH,
  ZIPCODE_SCHEMA_FIELD_NAME,
} from "./ZipCodeFormField.schema";

/**
 * ZipCodeFormField facilitates the input of a zipCode.
 */

export const ZipCodeFormField = (props) => {
  const {
    componentProps,
    disabled,
    label = i18n("ZipCodeFormField__LABEL"),
    name = ZIPCODE_SCHEMA_FIELD_NAME,
    selectedCountry,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("ZipCodeFormField__ARIA"),
        maxLength:
          selectedCountry === UNITED_STATES_COUNTRY_CODE
            ? ZIP_CODE_US_MAX_LENGTH
            : ZIP_CODE_NON_US_MAX_LENGTH,
        ...componentProps,
      },
      disabled,
      label,
      name,
    };
  }
};

export const zipCodeFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Content above the form field, used to identify the form field. */
  label: PropTypes.string,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,

  /** The selected country value used to determine the max length */
  selectedCountry: PropTypes.string,
};

ZipCodeFormField.propTypes = zipCodeFormFieldPropTypes;
